import { connect } from 'react-redux';
import { decorateWith, withName } from 'helpers/decorator';
import { searchFilterActions, selectSelectedCreditsRange } from './filters.helpers';
import { CreditsFilterOptions } from '../components/filters/CreditsFilterOptions';
import { FILTER_NAMES } from '../Search.constants';

const { setFilterValue } = searchFilterActions;

const mapStateToProps = state => {
  const creditsRange = selectSelectedCreditsRange(state);

  return {
    creditsRange,
  };
};

const mapDispatchToProps = {
  onCreditRangeChanged: value =>
    setFilterValue(FILTER_NAMES.CREDITS, value, {
      excludeFromWriteActions: true,
    }),
};

export const CreditsFilterOptionsContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('CreditsFilterOptionsContainer')
)(CreditsFilterOptions);
